module.exports = __webpack_public_path__ + "img/general-3.2.da62a6a9.svg";